import { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
}

export default function FAQ({ items }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="flex flex-col gap-3">
      {items.map((faq, index) => (
        <div
          key={index}
          className="rounded-xl border border-background-200/60 bg-background-50 overflow-hidden"
        >
          <button
            onClick={() => toggle(index)}
            className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer group"
          >
            <span className="font-heading text-sm md:text-base font-medium text-foreground-800 pr-4">
              {faq.question}
            </span>
            <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${openIndex === index ? "bg-primary-500 text-background-50 rotate-45" : "bg-secondary-100 text-secondary-600 group-hover:bg-secondary-200"}`}>
              <i className="ri-add-line text-base"></i>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${
              openIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
              {faq.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}